<template>
  <h2 v-if="title" class="fs-1">{{ title }}</h2>
  <p v-if="subTitle" class="fs-3">
    {{ subTitle }}
  </p>

  <div class="spinner-wrapper">
    <Spinner />
  </div>
</template>

<script setup lang="ts">
import Spinner from "@/apps/merchant3/shared-components/ui/Spinner.vue";

defineProps({
  title: {
    type: String,
    default: null,
  },
  subTitle: {
    type: String,
    default: null,
  },
});
</script>
